module.exports = __webpack_public_path__ + "static/media/pointy-hat.d042ac98.svg";